import { render, staticRenderFns } from "./ChannelAddPostModal.vue?vue&type=template&id=44d93eaf&"
import script from "./ChannelAddPostModal.vue?vue&type=script&lang=ts&"
export * from "./ChannelAddPostModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports